import { useEffect } from "react"
import { useAtomValue } from "jotai"
import { projectAtom } from "@/store/project/projects-state"
import { useRouteScene } from "@/routing/route-state"
import { projectSessionAtom, useProjectSession } from "@/routing/project-session"

export function useProjectRouteLifecycle() {
	const scene = useRouteScene()
	const project = useAtomValue(projectAtom)
	const sessionState = useAtomValue(projectSessionAtom)
	const { close } = useProjectSession()

	useEffect(() => {
		if (scene.isProjectRoute) {
			return
		}

		if (!project) {
			return
		}

		// Don't close if we're in the middle of opening a project
		// (setUpProject sets projectAtom before navigating to the project route)
		if (sessionState.status === "opening") {
			return
		}

		close({ saveChanges: true }).catch((error) => {
			console.error("Project close failed during route lifecycle", error)
		})
	}, [scene.isProjectRoute, project, close, sessionState.status])
}
